module.exports = __webpack_public_path__ + "img/zoomout.fa2e8a35.svg";